import { render, staticRenderFns } from "./MarkdownText.vue?vue&type=template&id=8d9dc7ea"
import script from "./MarkdownText.vue?vue&type=script&lang=js"
export * from "./MarkdownText.vue?vue&type=script&lang=js"
import style0 from "./MarkdownText.vue?vue&type=style&index=0&id=8d9dc7ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports